/*
 * followfood: Bundle-Builder Custom-Sticky-Bar (Etappe 2)
 *
 * Liest Easifys Quick-Summary-DOM (Thumbnails, Content-Text, Progress-Message),
 * haelt lokalen State, rendert eigene Bar via DOM-API (kein innerHTML).
 * Klick-Proxy auf Easifys [role=button]-Wrapper. Easify-Bar visuell off-screen.
 *
 * MutationObserver auf easify-box-set mit rAF-Debounce; volles Re-Build pro Tick.
 */
(function () {
  'use strict';

  var STICKY = document.querySelector('.ff-sticky');
  if (!STICKY) return;
  var DATA = window.ffBundleStickyData || {};
  // Free-Shipping-Fortschritt (#58): Schwelle (Cent) + Texte aus dem Liquid-Snippet
  // (window.ffBundleStickyConfig/I18n) — keine hartkodierten Werte/Strings im JS.
  var CONFIG = window.ffBundleStickyConfig || {};
  var I18N = window.ffBundleStickyI18n || {};

  // ── Easify-Selektoren zentral ─────────────────────────────
  // Wenn Easify ihre Klassen-Pattern ändert, müssen nur die Konstanten hier
  // angepasst werden statt 10+ Stellen im Code zu suchen. Aktivieren via
  // location.hash === '#ffdebug' → null-Selektoren loggen Warnings.
  var SEL = {
    card: 'easify-box-set [data-product-id]',
    cardById: function (pid) { return 'easify-box-set [data-product-id="' + pid + '"]'; },
    thumbWrap: '[class*="footer__product_list_selected_wrap"]',
    thumb: '[class~="productSelected_cosmetic__product_selected"]',
    filterPill: 'easify-box-set [class*="style1Header__item"]',
    stepper: '[class~="quantityInput_cosmetic__add_quantity_product"]',
    quickSummary: '.QUICK_SUMMARY_CONTENT_TEXT_TS',
    mobileTotal: '[class*="sidebarSummary__overview_sidebar_total"]'
  };
  var DEBUG = location.hash === '#ffdebug';
  function $$ (sel, root) {
    var found = (root || document).querySelector(sel);
    if (!found && DEBUG) console.warn('[ff-bundle] selector returned null:', sel);
    return found;
  }

  // ── State (Modul-lokal) ───────────────────────────────────
  var state = {
    items: [],         // [{ productId, qty, name, price, img }]
    total: 0,          // in Cent
    compareTotal: 0,   // in Cent
    savings: 0,        // in Cent
    tiers: [],         // [{ threshold, reward, label, icon }]
    currentCount: 0,
    progressMessage: '',
    minRequired: 0,    // Easify Box-Set conditions: QUANTITY/AMOUNT-Mindestwert
    maxAllowed: 0,     // 0 = kein Maximum
    requireBy: 'QUANTITY', // QUANTITY oder AMOUNT (in EUR)
    canCheckout: false
  };

  // ── DOM-Helper ────────────────────────────────────────────
  function el(tag, opts) {
    var node = document.createElement(tag);
    if (!opts) return node;
    if (opts.cls) node.className = opts.cls;
    if (opts.text != null) node.textContent = String(opts.text);
    if (opts.attrs) {
      for (var k in opts.attrs) {
        if (Object.prototype.hasOwnProperty.call(opts.attrs, k)) {
          node.setAttribute(k, String(opts.attrs[k]));
        }
      }
    }
    return node;
  }
  function svgEl(viewBox, attrs) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', viewBox);
    svg.setAttribute('xmlns', ns);
    svg.setAttribute('aria-hidden', 'true');
    if (attrs) {
      for (var k in attrs) {
        if (Object.prototype.hasOwnProperty.call(attrs, k)) svg.setAttribute(k, String(attrs[k]));
      }
    }
    return svg;
  }
  function svgChild(parent, tag, attrs) {
    var ns = 'http://www.w3.org/2000/svg';
    var n = document.createElementNS(ns, tag);
    if (attrs) for (var k in attrs) {
      if (Object.prototype.hasOwnProperty.call(attrs, k)) n.setAttribute(k, String(attrs[k]));
    }
    parent.appendChild(n);
    return n;
  }
  function empty(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }
  function formatEUR(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // ── Stubs (werden in Folge-Tasks implementiert) ───────────
  function buildMilestoneIcon(key) {
    var svg = svgEl('0 0 24 24', { width: 14, height: 14, fill: 'none', stroke: 'currentColor', 'stroke-width': 2 });
    if (key === 'snack') {
      svg.setAttribute('fill', 'currentColor');
      svg.setAttribute('stroke', 'none');
      svgChild(svg, 'path', { d: 'M12 2L4 7v6c0 4.97 3.58 9 8 9s8-4.03 8-9V7l-8-5z' });
    } else if (key === 'percent') {
      svgChild(svg, 'circle', { cx: 6.5, cy: 6.5, r: 2.5 });
      svgChild(svg, 'circle', { cx: 17.5, cy: 17.5, r: 2.5 });
      svgChild(svg, 'line', { x1: 5, y1: 19, x2: 19, y2: 5 });
    } else if (key === 'truck') {
      svgChild(svg, 'path', { d: 'M3 7h11v8H3zM14 10h4l3 3v2h-7z' });
      svgChild(svg, 'circle', { cx: 7, cy: 19, r: 1.75 });
      svgChild(svg, 'circle', { cx: 17, cy: 19, r: 1.75 });
    }
    return svg;
  }
  // Tier-Discount-Faktor für currentCount (z. B. count=10 → tier 10% → 0.10)
  function activeDiscountPct(count, tiers) {
    var pct = 0;
    for (var i = 0; i < tiers.length; i++) {
      if (count >= tiers[i].threshold) {
        var v = parseInt(tiers[i].label, 10);
        if (v > pct) pct = v;
      }
    }
    return pct;
  }
  // Min/Max-Bedingungen aus Easifys box_set.conditions parsen.
  // Easify rendert seine eigene CTA disabled wenn nicht erfüllt; wir
  // spiegeln das in unseren Custom-CTA + zeigen einen passenden Hint.
  function parseRequirements() {
    var out = { min: 0, max: 0, by: 'QUANTITY' };
    try {
      var conds = window.subscription_box_builder
        && window.subscription_box_builder.box_set
        && window.subscription_box_builder.box_set.conditions;
      if (!conds || !conds.length) return out;
      for (var i = 0; i < conds.length; i++) {
        var c = conds[i];
        var val = parseFloat(c.value);
        if (isNaN(val) || val <= 0) continue;
        if (c.condition === 'IS_GREATER_THAN_OR_EQUAL_TO') {
          out.min = val;
          out.by = c.attribute || 'QUANTITY';
        } else if (c.condition === 'IS_LESS_THAN_OR_EQUAL_TO') {
          out.max = val;
        }
      }
    } catch (e) { /* fallback: keine Bedingungen */ }
    return out;
  }
  // Easify-Thumb -> Produkt-Objekt aus seinem React-Fiber (memoizedProps.item):
  // { product:{id}, id(variant), title, quantity, price:{amount}, featuredImage:{url} }.
  // Die Footer-Thumb-Liste ist Easifys autoritativer Box-Inhalt und überlebt Filter-/Tab-Wechsel
  // (anders als die Karten, die beim Filtern aus dem DOM verschwinden) -> zuverlässige Quelle.
  function ffThumbItem(thumb) {
    try {
      var key = null, ks = Object.keys(thumb);
      for (var i = 0; i < ks.length; i++) { if (ks[i].indexOf('__reactFiber$') === 0 || ks[i].indexOf('__reactInternalInstance$') === 0) { key = ks[i]; break; } }
      var node = key ? thumb[key] : null, hops = 0;
      while (node && hops < 30) {
        var mp = node.memoizedProps;
        if (mp && mp.item && typeof mp.item === 'object' && mp.item.product) return mp.item;
        node = node.return || null; hops++;
      }
    } catch (e) {}
    return null;
  }
  // Frische Menge aus dem Karten-Stepper (Easify-Quantity-Input). Ziffern zwischen den +/-
  // Buttons; 0 wenn kein Stepper (ATC-Phase). Aktueller als der (verzögerte) Thumb-Fiber-Wert.
  function ffStepperQty(card) {
    var qd = card.querySelector('[class~="quantityInput_cosmetic__add_quantity_product"]');
    if (!qd) return 0;
    var txt = '', w = document.createTreeWalker(qd, NodeFilter.SHOW_TEXT, null), tn;
    while ((tn = w.nextNode())) {
      var pe = tn.parentElement;
      if (pe && pe.closest && pe.closest('.PRODUCT_CARD_QUANTITY_SELECTOR_BUTTON_TS')) continue;
      txt += tn.nodeValue;
    }
    var m = (txt || '').match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }
  // Produkt-Objekt aus dem React-Fiber einer Karte (title, featuredImage.url, priceRange…).
  // Nur für den Mobile-Fallback (dort gibt es keine Footer-Thumbs mit item-Objekt).
  function ffCardProduct(card) {
    try {
      var key = null, ks = Object.keys(card);
      for (var i = 0; i < ks.length; i++) { if (ks[i].indexOf('__reactFiber$') === 0 || ks[i].indexOf('__reactInternalInstance$') === 0) { key = ks[i]; break; } }
      var node = key ? card[key] : null, hops = 0;
      while (node && hops < 60) {
        var bags = [node.memoizedProps, node.pendingProps];
        for (var b = 0; b < bags.length; b++) {
          var bag = bags[b];
          if (bag && typeof bag === 'object') { for (var pk in bag) { var v = bag[pk]; if (v && typeof v === 'object' && typeof v.handle === 'string' && v.priceRange) return v; } }
        }
        node = node.return || null; hops++;
      }
    } catch (e) {}
    return null;
  }
  function readState() {
    // 1) Tiers zuerst (für Mobile-Total-Berechnung gebraucht)
    state.tiers = parseTiers('');
    var req = parseRequirements();
    state.minRequired = req.min;
    state.maxAllowed = req.max;
    state.requireBy = req.by;

    // 2) Box-Inhalt aus Easifys Footer-Thumbs (ffThumbItem liest product.id/quantity/price/
    //    featuredImage aus dem React-Fiber). Die Thumb-Liste ist Easifys autoritative Auswahl
    //    und überlebt einen Filter-/Tab-Wechsel — Karten verschwinden beim Filtern aus dem DOM.
    //    Kein Karten-Scan, kein (löschbarer) qty-Cache und keine Reconciliation mehr: genau die
    //    hatten beim Tab-Wechsel bereits ausgewählte, aber weggefilterte Produkte verworfen.
    //    Preis kommt aus item.price (Katalogpreis) -> compareTotal/„gespart" wie gehabt.
    var items = [];
    var thumbWrap = $$(SEL.thumbWrap);
    if (thumbWrap) {
      var thumbs = thumbWrap.querySelectorAll(SEL.thumb);
      for (var ti = 0; ti < thumbs.length; ti++) {
        var it = ffThumbItem(thumbs[ti]);
        if (!it || !it.product || !it.product.id) continue;
        var pid = String(it.product.id).replace(/\D/g, ''); // "gid://…/Product/123" -> "123"
        if (!pid) continue;
        var priceCents = (it.price && it.price.amount) ? Math.round(parseFloat(it.price.amount) * 100) : 0;
        // qty: der Thumb-Fiber `item.quantity` hinkt beim +/- EINE Aktion hinterher (React-Batch).
        // Der Karten-Stepper zeigt die Menge sofort korrekt → wenn die Karte im DOM ist (auch
        // gefiltert/hidden), von dort die frische qty lesen; sonst Fiber-qty als Fallback.
        // Steht das Produkt in mehreren Listen (Tablet), hat jede Karte ihre eigene Menge;
        // der Thumb zeigt die Summe, deshalb alle Karten des Produkts addieren.
        var qty = it.quantity || 1;
        var pcards = document.querySelectorAll('easify-box-set [data-product-id="' + pid + '"]');
        var cq = 0;
        for (var pc = 0; pc < pcards.length; pc++) cq += ffStepperQty(pcards[pc]);
        if (cq > 0) qty = cq;
        items.push({
          productId: pid,
          qty: qty,
          name: it.title || '',
          price: priceCents,
          img: (it.featuredImage && it.featuredImage.url) || (it.image && it.image.url) || ''
        });
      }
    } else {
      // Mobile: Easify rendert KEINEN Footer-Thumb-Container → aus den Karten mit qty>0 bauen.
      // Produktdaten (Name/Preis/Bild) aus dem React-Fiber der Karte (ffCardProduct).
      // Mobil steht ein Produkt in mehreren Produktlisten („Alle Produkte“ + Kategorie-Listen).
      // Easify führt es je Liste als eigene Position mit eigener Menge und summiert erst in
      // der Review. Deshalb die Mengen aller Karten eines Produkts addieren.
      var mcards = document.querySelectorAll('easify-box-set [data-product-id]');
      var mbyPid = {};
      for (var mc = 0; mc < mcards.length; mc++) {
        var mcard = mcards[mc];
        var mpid = mcard.getAttribute('data-product-id');
        if (!mpid) continue;
        var mqty = ffStepperQty(mcard);
        if (mqty <= 0) continue;
        if (mbyPid[mpid]) { mbyPid[mpid].qty += mqty; continue; }
        var mp = ffCardProduct(mcard);
        var mprice = (mp && mp.priceRange && mp.priceRange.minVariantPrice && mp.priceRange.minVariantPrice.amount) ? Math.round(parseFloat(mp.priceRange.minVariantPrice.amount) * 100) : 0;
        mbyPid[mpid] = {
          productId: mpid,
          qty: mqty,
          name: (mp && mp.title) || '',
          price: mprice,
          img: (mp && mp.featuredImage && mp.featuredImage.url) || ''
        };
        items.push(mbyPid[mpid]);
      }
    }

    // 4) Anzahl + Total
    //    Desktop: aus QUICK_SUMMARY_CONTENT_TEXT_TS „N Produkte im Bundle Gesamt: €X EUR".
    //    Mobile: Easify zeigt nur „N Produkte im Bundle" in overview_sidebar_total — kein Total.
    //    Fallback: Count = Σ qty der items; Total = compareTotal * (1 - activeDiscountPct).
    var contentEl = $$(SEL.quickSummary);
    var contentText = contentEl ? contentEl.textContent : '';
    var countMatch = contentText.match(/(\d+)\s*Produkt/i);
    var totalMatch = contentText.match(/€\s*([\d.,]+)/);
    if (!countMatch) {
      var mobileTotalEl = $$(SEL.mobileTotal);
      if (mobileTotalEl) countMatch = mobileTotalEl.textContent.match(/(\d+)\s*Produkt/i);
    }
    var qtySum = 0;
    for (var k = 0; k < items.length; k++) qtySum += items[k].qty || 0;
    // Count = Easifys QUICK_SUMMARY (autoritativ, für Tier-Berechnung); Fallback = Σ item-qty.
    // Keine Cache-Reconciliation mehr — items kommen direkt aus Easifys Thumb-Liste (kein Drift).
    state.currentCount = countMatch ? parseInt(countMatch[1], 10) : qtySum;

    // Annahme: deutsche Notation (€1.234,56). Bei US-Format (€1,234.56) explodiert das Ergebnis um Faktor 100.
    var rawTotal = totalMatch ? totalMatch[1].replace(/\./g, '').replace(',', '.') : '';
    var parsedTotal = rawTotal ? Math.round(parseFloat(rawTotal) * 100) : 0;

    // 5) compareTotal + savings + total
    var compare = 0;
    for (var j = 0; j < items.length; j++) compare += (items[j].price || 0) * (items[j].qty || 1);
    state.items = items;
    state.compareTotal = compare;

    if (parsedTotal > 0) {
      // Desktop: Easify liefert den definitiven Total
      state.total = parsedTotal;
    } else {
      // Mobile / kein Easify-Total: aus tier-Rabatt selber rechnen
      var pct = activeDiscountPct(state.currentCount, state.tiers);
      state.total = Math.round(compare * (100 - pct) / 100);
    }
    state.savings = compare > state.total ? compare - state.total : 0;

    // 6) Progress-Message für Hint
    var headerEl = document.querySelector('.QUICK_SUMMARY_HEADER_TEXT_TS');
    state.progressMessage = headerEl ? headerEl.textContent.trim() : '';

    // 7) Checkout-Voraussetzung prüfen — QUANTITY-Vergleich gegen count,
    //    AMOUNT-Vergleich gegen total in EUR (state.total ist in Cent).
    var currentMeasure = state.requireBy === 'AMOUNT' ? state.total / 100 : state.currentCount;
    var minOK = !state.minRequired || currentMeasure >= state.minRequired;
    var maxOK = !state.maxAllowed || currentMeasure <= state.maxAllowed;
    state.canCheckout = minOK && maxOK && state.currentCount > 0;

    // 8) Max-erreicht-Flag global setzen — CSS deaktiviert dann alle
    //    Plus-Stepper und ATC-Buttons auf den Karten.
    var atMax = !!state.maxAllowed && currentMeasure >= state.maxAllowed;
    document.documentElement.setAttribute('data-ff-bundle-at-max', atMax ? 'true' : 'false');
  }
  // Tiers kommen aus Easifys App-State (window.subscription_box_builder.box_set) —
  // Schwellen und Reward-Werte sind dort als Admin-Konfiguration gepflegt, nicht im
  // Code (dynamic-config-not-hardcoded). Zwei Quellen werden zusammengeführt:
  //
  //   1) box_set_discount.box_set_discount_rules       → % Mengenrabatt-Tiers
  //   2) additional_data.free_gift (wenn enabled=true) → Gratis-Geschenk-Tiers
  //
  // Tier-Objekt:
  //   { threshold, reward, pillLabel, label, type, icon }
  //     - reward    : Slot-Tile-Text (leerer Tier-Slot zeigt das mittig)
  //     - pillLabel : Header-Pill-Text (für renderHeaderPills "+ {pillLabel}")
  //     - label     : kurzer Bezeichner (für Progress-Marker-Beschriftung)
  //     - type      : "percent" | "gift" (für CSS-Modifier ff-sticky__pill--*)
  //     - icon      : Key für buildMilestoneIcon
  //
  // Fallback (defensiv): konservative Default-Tiers, falls Easify-State noch nicht
  // geladen oder Setup leer ist.
  function parseTiers(message) {
    var tiers = [];
    try {
      var sbb = window.subscription_box_builder;
      var bs = sbb && sbb.box_set;
      if (!bs) throw new Error('no box_set');

      // 1) Mengenrabatt-Tiers
      var rules = bs.box_set_discount && bs.box_set_discount.box_set_discount_rules;
      if (rules && rules.length) {
        for (var i = 0; i < rules.length; i++) {
          var r = rules[i];
          var ad = (r && r.additional_data) || {};
          if (!ad.minimum_value || ad.discount_on !== 'QUANTITY') continue;
          var threshold = parseInt(ad.minimum_value, 10);
          var value = ad.discount_value;
          if (!threshold || !value) continue;
          tiers.push({
            threshold: threshold,
            reward: value + '% Rabatt',
            pillLabel: value + '% Rabatt',
            label: value + '%',
            type: 'percent',
            icon: 'percent'
          });
        }
      }

      // 2) Free-Gift-Tiers — nur wenn vom Kunden im Easify-Admin aktiviert
      //    (enabled=true). Pill-/Slot-Label wird aus translation.de.success_message
      //    bereinigt: das Format ist Erfolgs-Benachrichtigung (z.B. "Gratis Snack
      //    freigeschaltet! 🎉"), unser UI braucht aber nur den Kern ("Gratis Snack").
      //    Falls Luke die Message anders formatiert, springt der Fallback "Gratis
      //    Geschenk" ein.
      var fg = bs.additional_data && bs.additional_data.free_gift;
      if (fg && fg.enabled && fg.tiers && fg.tiers.length) {
        var rawMsg = (fg.translation && fg.translation.de && fg.translation.de.success_message) || '';
        var pillLabel = rawMsg
          .replace(/[!.].*$/, '')                        // alles ab "!"/"." weg
          .replace(/\bfreigeschaltet\b/i, '')            // "freigeschaltet" raus
          .replace(/\bunlocked\b/i, '')                  // "unlocked" raus
          .replace(/[\u{1F300}-\u{1FAFF}]/gu, '')        // Emojis weg
          .replace(/\s+/g, ' ')
          .trim() || 'Gratis Geschenk';
        for (var j = 0; j < fg.tiers.length; j++) {
          var ft = fg.tiers[j];
          var fgThresh = parseInt(ft.min_value, 10);
          if (!fgThresh) continue;
          tiers.push({
            threshold: fgThresh,
            reward: pillLabel,
            pillLabel: pillLabel,
            label: pillLabel,
            type: 'gift',
            icon: 'snack'
          });
        }
      }

      if (tiers.length) {
        tiers.sort(function (a, b) { return a.threshold - b.threshold; });
        return tiers;
      }
    } catch (e) { /* defensiv: Fallback unten */ }
    return [
      { threshold: 6,  reward: '5% Rabatt',  pillLabel: '5% Rabatt',  label: '5%',  type: 'percent', icon: 'percent' },
      { threshold: 10, reward: '10% Rabatt', pillLabel: '10% Rabatt', label: '10%', type: 'percent', icon: 'percent' },
      { threshold: 15, reward: '15% Rabatt', pillLabel: '15% Rabatt', label: '15%', type: 'percent', icon: 'percent' }
    ];
  }
  function renderHeader() {
    var countEl = STICKY.querySelector('[data-ff-count]');
    if (countEl) countEl.textContent = String(state.currentCount);

    var totalEl = STICKY.querySelector('[data-ff-total]');
    if (totalEl) totalEl.textContent = formatEUR(state.total);

    var compareEl = STICKY.querySelector('[data-ff-compare]');
    var savingsEl = STICKY.querySelector('[data-ff-savings]');
    if (state.savings > 0) {
      if (compareEl) { compareEl.textContent = formatEUR(state.compareTotal); compareEl.hidden = false; }
      if (savingsEl) { savingsEl.textContent = formatEUR(state.savings) + ' gespart'; savingsEl.hidden = false; }
    } else {
      if (compareEl) compareEl.hidden = true;
      if (savingsEl) savingsEl.hidden = true;
    }

    // CTA disabled wenn Easify-Box-Set-Conditions nicht erfüllt sind.
    var ctaEl = STICKY.querySelector('[data-ff-cta]');
    if (ctaEl) ctaEl.disabled = !state.canCheckout;
  }
  // Header-Pills für ERREICHTE Tiers ("+ 10% Rabatt", "+ Gratis Snack" usw.).
  // 1 Pill pro Tier, in threshold-Reihenfolge (state.tiers ist bereits sortiert).
  // Reward-Tiers unterhalb count werden ausgelassen — Pills zeigen NUR was schon
  // freigeschaltet ist, der noch-nicht-erreichte Tier kommt im Hint-Text.
  function renderHeaderPills() {
    var container = STICKY.querySelector('[data-ff-pills]');
    if (!container) return;
    empty(container);
    var count = state.currentCount;
    for (var i = 0; i < state.tiers.length; i++) {
      var t = state.tiers[i];
      if (count < t.threshold) continue;
      var cls = 'ff-sticky__pill ff-sticky__pill--' + (t.type || 'discount');
      container.appendChild(el('span', { cls: cls, text: '+ ' + (t.pillLabel || t.reward) }));
    }
  }
  // Free-Shipping-Fortschritt (#58): „Noch X,XX € bis zum kostenlosen Versand!" neben den
  // Rabatt-Pills. Rest = Schwelle − Bundle-Zwischensumme (state.total, Cent). Bei erreichter
  // Schwelle Erreicht-Zustand (is-reached). Ohne gültige Schwelle oder leeres Bundle: ausgeblendet.
  // state.total steckt bereits in headSignature() → Re-Render bei Total-Änderung ist abgedeckt.
  function renderFreeShipping() {
    var box = STICKY.querySelector('[data-ff-shipping]');
    if (!box) return;
    var threshold = CONFIG.freeShippingThresholdCents;
    if (!threshold || threshold <= 0 || state.currentCount <= 0) {
      box.hidden = true;
      box.textContent = '';
      box.classList.remove('is-reached');
      return;
    }
    var remaining = threshold - state.total;
    if (remaining > 0) {
      box.textContent = (I18N.freeShippingRemaining || '').replace('__AMT__', formatEUR(remaining));
      box.classList.remove('is-reached');
    } else {
      box.textContent = I18N.freeShippingReached || '';
      box.classList.add('is-reached');
    }
    box.hidden = false;
  }
  function renderProgress() {
    var bar = STICKY.querySelector('[data-ff-progress]');
    var hint = STICKY.querySelector('[data-ff-hint]');
    if (!bar) return;

    empty(bar);
    if (!state.tiers.length) return;
    var tierCount = state.tiers.length;
    var count = state.currentCount;
    var maxThreshold = state.tiers[tierCount - 1].threshold;

    // Marker-Position PROPORTIONAL zur Schwelle (z. B. 6/15 = 40%, 10/15 = 66.7%,
    // 15/15 = 100%). Wenn 4 Tiers konfiguriert wären, sähen die Abstände entsprechend
    // anders aus. Fortschrittsbalken-Fill läuft linear zwischen Markern: jede Linie
    // zwischen 2 Markern füllt sich proportional, basierend auf der Anzahl Items
    // zwischen den beiden Schwellen.
    function markerPct(idx) { return (state.tiers[idx].threshold / maxThreshold) * 100; }
    var fillPct = 0;
    for (var i = 0; i < tierCount; i++) {
      var t = state.tiers[i];
      if (count >= t.threshold) {
        fillPct = markerPct(i);
        continue;
      }
      var prevThreshold = i === 0 ? 0 : state.tiers[i - 1].threshold;
      var span = t.threshold - prevThreshold;
      var progress = span > 0 ? Math.max(0, (count - prevThreshold) / span) : 0;
      var prevPct = i === 0 ? 0 : markerPct(i - 1);
      fillPct = prevPct + progress * (markerPct(i) - prevPct);
      break;
    }

    var track = el('div', { cls: 'ff-sticky__progress-track' });
    var fill = el('div', { cls: 'ff-sticky__progress-fill' });
    fill.style.width = fillPct + '%';
    track.appendChild(fill);

    // Marker liegen IM Track (nicht im Bar-Container), damit ihre
    // left:X% relativ zur Track-Breite ist und Fill + Marker konsistent
    // dieselbe Achse haben.
    for (var j = 0; j < tierCount; j++) {
      var tier = state.tiers[j];
      var reached = count >= tier.threshold;
      var marker = el('div', { cls: 'ff-sticky__milestone' + (reached ? ' is-reached' : '') });
      marker.style.left = (tier.threshold / maxThreshold * 100) + '%';
      marker.appendChild(el('div', { cls: 'ff-sticky__milestone-circle', text: String(tier.threshold) }));
      // tier.label (kurz, z. B. "10%") statt tier.reward ("10% Rabatt") — die
      // Marker-Achse ist zu eng für die langen Reward-Texte (Labels überlappten).
      marker.appendChild(el('div', { cls: 'ff-sticky__milestone-label', text: tier.label }));
      track.appendChild(marker);
    }

    bar.appendChild(track);

    if (hint) hint.textContent = state.progressMessage || '';

    fitProgress();
  }

  // Progress-Track nur anzeigen, wenn er mind. PROGRESS_MIN_WIDTH px Breite
  // bekommt. Auf engen Layouts (zu viele Pills → Trigger a) wäre die Marker-Achse
  // zu schmal für lesbare Labels, dann lieber ganz ausblenden. Die verfügbare
  // Breite wird aus der Header-Breite minus der Geschwister-Elemente berechnet
  // (nicht aus dem Track selbst) — dadurch loop-frei trotz display:none.
  // Mobile (< 768px) ist der Track per CSS-@media ohnehin aus (Trigger b).
  // Muss der festen Track-Breite entsprechen (.ff-sticky__progress flex-basis
  // 290px in followfood.css): der Track hat jetzt eine konstante Breite (damit er
  // nicht schrumpft, wenn die Pill erscheint) — passt er nicht (< 290px frei),
  // blendet fitProgress() ihn aus statt ihn überlaufen zu lassen.
  var PROGRESS_MIN_WIDTH = 290;
  function fitProgress() {
    var bar = STICKY.querySelector('[data-ff-progress]');
    var header = STICKY.querySelector('.ff-sticky__header');
    if (!bar || !header) return;
    if (window.innerWidth < 768) return; // Mobile: CSS regelt das
    var siblings = Array.from(header.children).filter(function (c) {
      return c !== bar && getComputedStyle(c).display !== 'none';
    });
    var used = siblings.reduce(function (sum, eln) {
      return sum + eln.getBoundingClientRect().width;
    }, 0);
    var cs = getComputedStyle(header);
    var gap = parseFloat(cs.columnGap || cs.gap) || 0;
    var pad = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
    var available = header.clientWidth - pad - used - gap * siblings.length;
    // Alle Meilensteine erreicht → kein nächstes Ziel mehr, Progress ausblenden.
    // Gibt Platz für die dann 3 Pills nebeneinander, Bar bleibt flach.
    var maxThreshold = state.tiers.length ? state.tiers[state.tiers.length - 1].threshold : 0;
    var allReached = maxThreshold > 0 && state.currentCount >= maxThreshold;
    bar.classList.toggle('ff-progress-hide', allReached || available < PROGRESS_MIN_WIDTH);
  }
  function makeFilledSlot(slot, pos) {
    var node = el('div', { cls: 'ff-sticky__slot', attrs: { 'data-ff-img': slot.img || '' } });
    if (slot.img) {
      var img = document.createElement('img');
      img.className = 'ff-sticky__slot-img';
      img.alt = slot.name || ('Bundle-Slot ' + pos);
      img.loading = 'eager';
      img.src = slot.img;
      node.appendChild(img);
    }
    var rmBtn = el('button', { cls: 'ff-sticky__slot-remove', attrs: { type: 'button', 'data-ff-remove': '', 'aria-label': 'Entfernen' } });
    var xSvg = svgEl('0 0 24 24', { width: 24, height: 24, fill: 'currentColor' });
    svgChild(xSvg, 'path', { 'fill-rule': 'evenodd', 'clip-rule': 'evenodd', d: 'M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z' });
    rmBtn.appendChild(xSvg);
    node.appendChild(rmBtn);
    return node;
  }
  function renderSlots() {
    var container = STICKY.querySelector('[data-ff-slots]');
    if (!container) return;

    // Vorhandene gefüllte Slots nach Bild-URL poolen → beim Neuaufbau WIEDERVERWENDEN. Ein neu
    // erzeugtes <img> würde (auch aus dem Cache) kurz neu laden = sichtbares Flackern bei jedem
    // Add/Remove; ein wiederverwendetes DOM-Element behält sein bereits dekodiertes Bild.
    var pool = {};
    var existingFilled = container.querySelectorAll('.ff-sticky__slot.is-filled');
    for (var e = 0; e < existingFilled.length; e++) {
      var eurl = existingFilled[e].getAttribute('data-ff-img') || '';
      (pool[eurl] = pool[eurl] || []).push(existingFilled[e]);
    }
    empty(container); // löst Kinder ab; gepoolte Nodes bleiben per Referenz erhalten (nicht zerstört)

    // Expansion: Produkt-Item × qty → N Slot-Entries
    var slots = [];
    for (var i = 0; i < state.items.length; i++) {
      var item = state.items[i];
      for (var q = 0; q < item.qty; q++) {
        slots.push({ filled: true, productId: item.productId, img: item.img, name: item.name });
      }
    }

    // Leere Slots bis zur höchsten Schwelle (mind. höchste Schwelle)
    var maxThreshold = state.tiers.length ? state.tiers[state.tiers.length - 1].threshold : 16;
    var targetSlots = Math.max(maxThreshold, slots.length + 5);
    while (slots.length < targetSlots) slots.push({ filled: false });

    // Tier-Map: schnelles Lookup, ob Slot-Position N ein Meilenstein ist.
    var tierByPos = {};
    for (var t = 0; t < state.tiers.length; t++) tierByPos[state.tiers[t].threshold] = state.tiers[t];

    for (var s = 0; s < slots.length; s++) {
      var pos = s + 1;
      var slot = slots[s];
      var num = pos < 10 ? '0' + pos : String(pos);
      var tier = tierByPos[pos] || null;
      var reached = tier && state.currentCount >= tier.threshold;

      var cls = 'ff-sticky__slot';
      cls += slot.filled ? ' is-filled' : ' is-empty';
      if (tier) cls += ' is-tier' + (reached ? ' is-tier-reached' : '');

      var slotNode;
      if (slot.filled) {
        // Slot mit gleichem Bild aus dem Pool wiederverwenden (kein Bild-Reload) — sonst neu bauen.
        var key = slot.img || '';
        slotNode = (pool[key] && pool[key].length) ? pool[key].shift() : makeFilledSlot(slot, pos);
      } else {
        slotNode = el('div', {});
        if (tier) slotNode.appendChild(el('span', { cls: 'ff-sticky__slot-tier-text', text: tier.reward }));
        else slotNode.appendChild(el('span', { cls: 'ff-sticky__slot-num', text: num }));
      }
      slotNode.className = cls;
      slotNode.setAttribute('data-slot-index', s);
      slotNode.setAttribute('data-product-id', slot.productId || '');

      container.appendChild(slotNode);
    }
  }
  function clickCardMinus(card) {
    if (!card) return false;
    var qtyDisplay = card.querySelector('[class~="quantityInput_cosmetic__add_quantity_product"]');
    if (!qtyDisplay) return false;
    var steps = qtyDisplay.querySelectorAll('[role="button"]');
    if (steps.length < 1) return false;
    steps[0].click();
    return true;
  }
  function proxyRemoveSlot(productId) {
    if (!productId) return false;
    // IMMER Karten-Stepper-Minus klicken (steppers[0]) — reduziert qty um 1.
    // Easifys Thumb-X im Footer würde stattdessen das Produkt komplett entfernen
    // (qty → 0), egal wie viele drin sind. Das passt nicht zur Slot-Semantik:
    // jeder Slot ist ein einzelnes Item, das einzeln entfernt werden soll.
    // Scope auf easify-box-set: ohne Scope würde die Query auch unsere
    // eigenen Sticky-Slots matchen (data-product-id ist dort auch gesetzt) →
    // clickCardMinus würde fehlschlagen und Auto-Switch nie triggern.
    // Steht das Produkt in mehreren Listen, trägt nur die Karte mit Stepper eine Menge:
    // die erste Karte mit Stepper nehmen, nicht einfach die erste im DOM.
    var cards = document.querySelectorAll(SEL.cardById(productId));
    for (var k = 0; k < cards.length; k++) {
      if (clickCardMinus(cards[k])) return true;
    }
    if (cards.length) return false;
    // Card nicht im DOM → vermutlich durch aktiven Pill-Filter ausgeblendet
    // (Easify entfernt gefilterte Cards komplett, nicht nur display:none).
    // Auto-Switch zu ALLES, dann minus klicken sobald die Card gerendert ist.
    var pills = document.querySelectorAll(SEL.filterPill);
    var allesPill = null;
    for (var i = 0; i < pills.length; i++) {
      if (pills[i].textContent.trim().toUpperCase() === 'ALLES') { allesPill = pills[i]; break; }
    }
    if (!allesPill) return false;
    allesPill.click();
    // Easify rendert async — 50ms reicht für die Render-Welle. Falls die Card
    // noch nicht da ist, nochmal nach 200ms versuchen (langsame Geräte/Netz).
    setTimeout(function () {
      var c2 = document.querySelector(SEL.cardById(productId));
      if (c2) { clickCardMinus(c2); return; }
      setTimeout(function () {
        var c3 = document.querySelector(SEL.cardById(productId));
        if (c3) clickCardMinus(c3);
      }, 200);
    }, 50);
    return true;
  }

  function proxyCTA() {
    // Bei nicht erfüllten Bedingungen nichts tun — Easifys CTA würde
    // ohnehin disabled sein, aber wir blockieren preventiv.
    if (!state.canCheckout) return false;
    var selectors = [
      '[class*="footer__"] .QUICK_SUMMARY_BUTTON_NEXT_TS',
      '[class*="sidebarSummary__"] .QUICK_SUMMARY_BUTTON_NEXT_TS',
      '.QUICK_SUMMARY_BUTTON_NEXT_TS'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) { el.click(); return true; }
    }
    return false;
  }

  // ── Expand/Collapse ───────────────────────────────────────
  // Einzige Stelle, die data-expanded + aria-expanded synchron hält (Toggle-Klick
  // und Auto-Expand teilen sich das).
  function setExpanded(expanded) {
    STICKY.setAttribute('data-expanded', expanded ? 'true' : 'false');
    var toggle = STICKY.querySelector('[data-ff-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    // Chevron-Richtung: CSS-Rotation via [data-expanded]-Attribut auf STICKY.
  }

  // Auto-Expand (#20): Auf Desktop (>= 768px) klappt die Bar EINMAL auf, sobald
  // das erste Produkt hinzugefügt wird (0 -> >0). Danach respektiert sie wieder
  // die manuelle Toggle-Wahl (Guard via `autoExpanded`). Leert sich das Bundle
  // komplett (zurück auf 0), wird eine auto-geöffnete Bar wieder zugeklappt und
  // der Guard zurückgesetzt — sonst bliebe ein leerer Body mit Placeholder-Slots
  // offen (remove-to-empty-Fix). Mobile bleibt unberührt (Bar bewusst zu).
  var prevCount = 0;
  var autoExpanded = false;
  function maybeAutoExpand() {
    if (state.currentCount === 0) {
      if (autoExpanded) setExpanded(false);
      autoExpanded = false;
    } else if (!autoExpanded && prevCount === 0 && window.innerWidth >= 768) {
      setExpanded(true);
      autoExpanded = true;
    }
    prevCount = state.currentCount;
  }

  // Review-Step erkennen (#23): Die Produktauswahl (Builder) läuft ohne `step`-
  // Param bzw. step=0. Nach „Weiter" wechselt Easify per History-API auf step=1
  // (die „ÜBERPRÜFE DEIN BUNDLE"-Zusammenfassung) — dort gehört die Sticky-Bar
  // nicht hin: das Karten-Grid ist durch die Summary ersetzt, sie läse 0 Artikel.
  // Same-Template-SPA → Liquid kann das nicht trennen, daher hier. Query-Param
  // statt gehashter Klassen/Text: sprach- und hash-unabhängig stabil.
  function isReviewStep() {
    var step = new URLSearchParams(location.search).get('step');
    return step != null && step !== '0';
  }

  // ── Bootstrap ─────────────────────────────────────────────
  // Signatur des render-relevanten Zustands. Easify feuert Dauer-characterData-Mutationen
  // (Sales-Notifications/Timer) → unser Observer triggert ständig. Ohne Vergleich würde die
  // Bar bei JEDEM Tick komplett neu gebaut (Slots/Bilder neu → sichtbarer Flicker). Wir
  // bauen das DOM nur neu, wenn sich Anzahl/Total/Ersparnis/Items/Tiers wirklich geändert haben.
  // Zwei getrennte Signaturen: ITEMS (Produkte/Menge/Bild) treiben den TEUREN Slot-Rebuild
  // (Grid + <img>), HEADER (Anzahl/Total/Ersparnis/Progress) nur billige Text-Updates. Easify
  // feuert pro Add ~400 Mutationen (Sales-Ticker etc.) → ohne Trennung baute sich das Slot-Grid
  // 30× neu auf (Lag + Bild-Neuladen). So läuft renderSlots nur bei echter Item-Änderung.
  function itemsSignature() {
    var s = '';
    for (var i = 0; i < state.items.length; i++) {
      var it = state.items[i];
      s += it.productId + ':' + it.qty + ':' + (it.img ? 1 : 0) + ',';
    }
    // Die Slot-Labels hängen an den Tiers. Easifys box_set kann erst nach dem ersten
    // Render da sein (dann greifen die Fallback-Tiers), deshalb zeichnet ein Tier-Wechsel
    // die Slots neu, auch bei leerer Kiste.
    for (var t = 0; t < state.tiers.length; t++) {
      s += '|' + state.tiers[t].threshold + ':' + state.tiers[t].reward;
    }
    return s;
  }
  function headSignature() {
    return state.currentCount + '|' + state.total + '|' + state.savings + '|' + state.canCheckout + '|' + state.progressMessage + '|' + state.tiers.length;
  }
  var lastItemsSig = null, lastHeadSig = null;
  var pending = false;
  function scheduleRender() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      // Im Review-Step ausblenden (CSS: .ff-sticky[hidden] { display:none }) und
      // State-Render überspringen — sonst zeigt die Bar fälschlich „0" (#23).
      if (isReviewStep()) {
        STICKY.setAttribute('hidden', '');
        return;
      }
      readState();
      var iSig = itemsSignature(), hSig = headSignature();
      var itemsChanged = iSig !== lastItemsSig;
      var headChanged = hSig !== lastHeadSig;
      if (!itemsChanged && !headChanged) { STICKY.removeAttribute('hidden'); return; }
      lastItemsSig = iSig; lastHeadSig = hSig;
      maybeAutoExpand();
      renderHeader();
      renderHeaderPills();
      renderFreeShipping();
      renderProgress();
      if (itemsChanged) renderSlots(); // teuer (Slot-Grid + Bilder) — nur bei echter Item-Änderung
      STICKY.removeAttribute('hidden');
    });
  }

  function init() {
    var toggle = STICKY.querySelector('[data-ff-toggle]');
    if (toggle) toggle.addEventListener('click', function () {
      var expanded = STICKY.getAttribute('data-expanded') === 'true';
      setExpanded(!expanded);
      // Manuelles Toggle gilt als „User hat entschieden" → Auto-Expand nicht
      // erneut erzwingen, solange das Bundle gefüllt bleibt (#20).
      autoExpanded = true;
    });

    var cta = STICKY.querySelector('[data-ff-cta]');
    if (cta) cta.addEventListener('click', proxyCTA);

    // Scroll-Buttons (links + rechts): scrollen um ~3 Slot-Breiten. Beide Pfeile
    // werden via [hidden] nur gezeigt, wenn in die jeweilige Richtung gescrollt
    // werden kann — der rechte also nur bei Rechts-Scroll-Spielraum (followfood #22).
    var slotsEl = STICKY.querySelector('[data-ff-slots]');
    var prevBtn = STICKY.querySelector('[data-ff-slots-prev]');
    var nextBtn = STICKY.querySelector('[data-ff-slots-next]');
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (slotsEl) slotsEl.scrollBy({ left: 240, behavior: 'smooth' });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () {
      if (slotsEl) slotsEl.scrollBy({ left: -240, behavior: 'smooth' });
    });
    function updateScrollButtons() {
      if (!slotsEl) return;
      var maxScroll = slotsEl.scrollWidth - slotsEl.clientWidth;
      // 2px Toleranz für sub-pixel-rendering und scroll-snap-Drift.
      var canPrev = slotsEl.scrollLeft > 2;
      var canNext = maxScroll > 2 && slotsEl.scrollLeft < maxScroll - 2;
      if (prevBtn) prevBtn.hidden = !canPrev;
      if (nextBtn) nextBtn.hidden = !canNext;
    }
    if (slotsEl) slotsEl.addEventListener('scroll', updateScrollButtons);
    window.addEventListener('resize', updateScrollButtons);
    // Track-Sichtbarkeit (Trigger a) bei Viewport-Resize neu bewerten; bei
    // Tier-/Pill-Änderungen geschieht das ohnehin via renderProgress().
    window.addEventListener('resize', fitProgress);
    // updateScrollButtons nach jedem rAF-Render anstoßen — scheduleRender ist
    // eine function-declaration in der IIFE-scope, kann hier neu zugewiesen werden.
    var origScheduleRender = scheduleRender;
    scheduleRender = function () {
      origScheduleRender();
      // Doppel-rAF, damit Layout-Reflow nach dem Render abgeschlossen ist.
      requestAnimationFrame(function () { requestAnimationFrame(updateScrollButtons); });
    };
    // Erst-Check für den initialen Bar-Render (vor Mutation-Events).
    requestAnimationFrame(function () { requestAnimationFrame(updateScrollButtons); });

    STICKY.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-ff-remove]');
      if (!btn) return;
      var slot = btn.closest && btn.closest('.ff-sticky__slot');
      if (!slot) return;
      var pid = slot.getAttribute('data-product-id');
      if (pid) {
        proxyRemoveSlot(pid);
        // Easify rebuildet die Karte (Stepper ↔ ATC) async — eine spätere
        // Re-Render-Welle stellt sicher dass wir den finalen DOM-State sehen.
        setTimeout(scheduleRender, 250);
        setTimeout(scheduleRender, 600);
      }
    });

    scheduleRender();

    // Easify führt mehrere DOM-Wellen pro Aktion aus. Ein rein zurücksetzender Debounce
    // rendert erst NACH dem Settle → spürbare Verzögerung (Thumb ist bei ~46ms da, Bar erst
    // ~210ms). Deshalb Leading-Edge + Trailing: beim ersten Mutation-Event einer Aktion SOFORT
    // rendern (responsiv — der Thumb-Fiber ist Easifys autoritativer State, auch mitten in einer
    // Welle konsistent lesbar), dann nach dem Settle nochmal für den finalen State (Count/Total).
    // scheduleRender ist rAF-debounced + überspringt DOM-Rebuild bei gleicher Signatur → günstig.
    // Festes, NICHT zurücksetzendes Fenster: Easifys Sales-Ticker feuert dauernd characterData.
    // Ein zurücksetzender Debounce würde dadurch nie auslösen → die Bar bleibt „einen hinterher"
    // (nur jede 2. Aktion sichtbar). Das feste 80ms-Fenster feuert ab der ERSTEN Mutation
    // zuverlässig einmal, liest den dann bereits gesetzten State (Thumb ist ~46ms da).
    var mutTimer = null;
    function scheduleMutRender() {
      if (mutTimer) return;
      mutTimer = setTimeout(function () { mutTimer = null; scheduleRender(); }, 80);
    }
    var host = document.querySelector('easify-box-set') || document.body;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { scheduleMutRender(); return; }
        if (muts[i].type === 'characterData') { scheduleMutRender(); return; }
      }
    }).observe(host, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
